import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_logged/c/$club/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Navigate from={Route.fullPath} to="/c/$club/analytics" />;
}
